import { ScriptsActive } from '@Containers/Scripts';

const ScriptsActivePage: React.FunctionComponent = (): JSX.Element => (
  <ScriptsActive />
);

export default ScriptsActivePage;
